import { useMemo } from 'react'

import { useCurrentLanguage, useTranslate } from 'lib/tolgee'

import type { StorageProgressBarModel, StorageProgressBarModelProps } from './storage-progress-bar.types'
import { calculatePercentage, formatStorageLabelTranslation } from './storage-progress-bar.utils'

export const useStorageProgressModel = ({
  currentValue,
  maxValue,
}: StorageProgressBarModelProps): StorageProgressBarModel => {
  const t = useTranslate()
  const currentLanguage = useCurrentLanguage()

  const percentage = useMemo(() => calculatePercentage(currentValue, maxValue), [currentValue, maxValue])
  const label = useMemo(
    () => t(formatStorageLabelTranslation(currentValue, maxValue, currentLanguage)),
    [t, currentValue, maxValue, currentLanguage]
  )

  return {
    percentage,
    label,
  }
}
